import { Box } from '@mui/material';
import React from 'react';
import { groupBy } from 'lodash';
import { Chart } from '@/components/Base/Chart.tsx';
import {
  ConsolidationDataScoreMovimentacaoEscolarType,
} from '@/features/dashboard/types/ConsolidationDataScoreMovimentacaoEscolar';

type PropsType = {
  backgroundStyle?: boolean;
  lineColor?: string[];
  title?: string;
  data: ConsolidationDataScoreMovimentacaoEscolarType[];
};

const ScoreMovimentacaoEscolarChart: React.FC<PropsType> = ({ backgroundStyle = false, lineColor, title, data }) => {

  const option = {
    title: {
      text: title,
      padding: [
        16,
        5,
        5,
        23,
      ],
      textStyle: {
        fontSize: '14px'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },
    },
    legend: {
      data: ['Entradas', 'Saídas'], // Reordered legend
      right: '0',
      padding: [
        32,
        23,
        5,
        5,
      ],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: Object.keys(groupBy(data, 'ano')).map((value) => Number(value)),
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          margin: 30,
        },
      },
    ],
    series: [
      {
        name: 'Entradas',
        type: 'line',
        smooth: true,
        stack: 'Total',
        label: {
          show: true,
          position: 'bottom',
          color: '#000',
        },
        symbol: '',
        symbolSize: 20,
        areaStyle: {
          color: backgroundStyle ? 'rgba(252, 159, 159, 0.6)' : 'transparent',
        },
        lineStyle: {
          color: lineColor[1],
          width: 4,

        },
        itemStyle: {
          borderWidth: 1,
          // borderColor: '#EE6666',
          color: '#000',
        },
        emphasis: {
          focus: 'series',
        },
        data: data.map((item) => Number(item.valor)),
      },
      {
        data: data.map((item) => Number(item.valor_secundario)),
        type: 'line',
        smooth: true,
        stack: 'a',
        name: 'Saídas',
        itemStyle: {
          borderWidth: 1,
          color: '#000',
        },
        label: {
          show: true,
          position: 'bottom',
          color: '#000',
        },
        symbol: '',
        symbolSize: 20,
        lineStyle: {
          color: lineColor[0],
          width: 4,

        },

      },
    ],
  };

  // @ts-ignore
  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      {
        // @ts-ignore
        <Chart option={option} />
      }
    </Box>
  );
};

export default ScoreMovimentacaoEscolarChart;
